import { codeSplit, Controller } from 'bernie-core';
import { PageData } from 'bernie-http';

export class GroundTransportationSearchController implements Controller {
  public bundles = ['gts'];
  public component = codeSplit(() => import(/* webpackChunkName: "gts" */ 'src/common/views/ground-transportation/search'));
  public pageId = 'page.LX-GT-Search,GT,20';
  public path = '/ground-transfers/search';
  public exact = true;
  public routeName = 'GroundTransportationSearch';
  public routeData = {
    rfrrNamespace: 'GT.SRP',
    pageName: 'GROUNDTRANSFERS',
  };

  public fetch(): Promise<any> {
    return Promise.resolve();
  }
  public fetchPageData(): Promise<PageData> {
    return Promise.resolve({
      title: 'Ground Transportation, noice!',
      seo: {
        robots: 'noindex',
      },
    }) as Promise<PageData>;
  }
}
